/**
 * Layout: Hero - Bedankt
 * Slug: hero_bedankt
 */

function toggleMute(video, controls) {
	video.muted = !video.muted;
	controls.classList.toggle("muted", video.muted);
	controls.classList.toggle("unmuted", !video.muted);
}
function togglePlayback(video, controls) {
	video.paused ? video.play() : video.pause();
	controls.classList.toggle("paused", video.paused);
	controls.classList.toggle("playing", !video.paused);
}

document.addEventListener('DOMContentLoaded', function() {
    const layouts = document.querySelectorAll('.flex-layout.hero_bedankt-layout');

	layouts.forEach((layout) => {
		const video = layout.querySelector(".pk-video");
		const videoControls = layout.querySelector(".video-controls");
		const volumeControl = videoControls.querySelector(".volume");
		const playbackControl = videoControls.querySelector(".play-pause");

		volumeControl.addEventListener("click", () => toggleMute(video, videoControls));
		playbackControl.addEventListener("click", () => togglePlayback(video, videoControls));
	});
});
